import { elements } from "chart.js"
import {
    ResidentAyudaPage,
    ResidentProfilePage,
    ResidentTransactionPage,
} from "../../pages/resident"


export const residentRoutes = [
    { path: "/wallet", element: <ResidentTransactionPage /> },
    { path: "/resident-ayuda", element: <ResidentAyudaPage /> },
    { path: "/resident-profile", element: <ResidentProfilePage /> }
]
